import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

// Import flag images
import french from "../../assets/flags/fr.png";
import english from "../../assets/flags/en.png";
import spanish from "../../assets/flags/es.png";
import portuguese from "../../assets/flags/pt.png";

// Define TypeScript types
interface LanguageOption {
    value: string;
    label: string;
    icon: string;
}

interface LanguageDropdownProps {
    onChange: (value: string) => void;
    value: string;
}

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({ onChange, value }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    // Language options with flags
    const languageOptions: LanguageOption[] = [
        { value: "fr", label: "Français", icon: french },
        { value: "en", label: "English", icon: english },
        { value: "es", label: "Español", icon: spanish },
        { value: "pt", label: "Português", icon: portuguese },
    ];

    const formatOptionLabel = (option: LanguageOption) => (
        <div style={{ display: "flex", alignItems: "center" }}>
            <img src={option.icon} alt={option.label} style={{ width: "20px", marginRight: "8px" }} />
            <span>{option.label}</span>
        </div>
    );

    return (
        <div className="rewind-lang-wrap" style={{ width: 170 }}>
            <Select
                classNamePrefix="rewind-lang"
                value={languageOptions.find((lang) => lang.value === value)}
                onChange={(selected) => selected && onChange(selected.value)}
                options={languageOptions}
                formatOptionLabel={formatOptionLabel}
                placeholder={t("selectLanguage")}
            />
        </div>
    );
};

export default LanguageDropdown;
